import { LayoutButton } from "GameObjects/UI/LayoutButton";

export class SettingsMenuTabButton extends LayoutButton {
    readonly affectedBySettingsScale = false;
}